import React, { FunctionComponent } from "react";

import { useSearchAccessoriesByVehicle } from "../../../queries/useSearchAccessoriesByVehicle";
import { useProductModalHash } from "../ProductModal";
import { AccessoryDetails } from "./AccessoryDetails";

export const AccessoryModalContent: FunctionComponent = () => {
  const { data: results } = useSearchAccessoriesByVehicle();
  const { itemId } = useProductModalHash();

  const product = results?.filteredParts.find(
    ({ partDetails }) => partDetails.primaryPart.itemId === itemId
  );

  return <AccessoryDetails part={product || null} />;
};
